
import get from 'lodash.get'

export default function useReportDownloadForm() {


    const reportDataConstructor = (data)=> {

        if (!get(data, 'report')) return {}

        let reports = data.report.map((report)=> {
            return (({id, name, root_model, filterfield_set}) => ({ id, name, root_model, filterfield_set }))(report)
        })

        return {
            'id': data.id,
            'reports': reports
        }

    }

    const requestDataConstructor = (initialData, formData) => {

        if (initialData !== formData && Object.keys(formData).length > 0) {
            let reports = formData['reports']
            return reports.length === 0 ? {} : {"reports": reports}
        }
        return {}
    };


    return {
        reportDataConstructor,
        requestDataConstructor,
    }
}
